import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	calmLogoAriaLabel: {
		id: 'generics.calmLogoAriaLabel2',
		defaultMessage: 'Calm Logo - Link to calm.com Homepage',
		description: 'A link that takes you to the homepage',
	},
});
